// components/StructuredDataHeadOnly.tsx
'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function StructuredDataHeadOnly() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname !== '/') return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      url: "https://dimaak.com/",
      sameAs: [
        "https://www.facebook.com/dimaaktours",
        "https://www.instagram.com/dimaaktours/",
        "https://www.linkedin.com/company/dimaaktours/",
        "https://www.youtube.com/channel/UCqA1BWL3xcDdBlGoC8TmNBw",
      ],
      logo: "https://dimaak.com/_next/static/media/logo.710da178.svg",
      name: "Dimaak Tours",
      description:
        "Create unforgettable memories with our 100% customisable international holiday packages. Tailor-made itineraries, personalized experiences. Start planning now!",
      email: "contact@dimaak.com",
      telephone: "+91-9600099777",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Dimaak Travel Technologies Private Limited Ask Towers, Second Floor Plot No.183 Sri Sai Nagar Third Main Road Sri Sai Nagar, Okkiyam Thoraipakkam",
        addressLocality: "Chennai",
        addressRegion: "Tamilnadu",
        postalCode: "600097",
        addressCountry: "IN",
      },
    });

    document.head.appendChild(script);

    // Optional cleanup (if client navigates away)
    return () => {
      document.head.removeChild(script);
    };
  }, [pathname]);

  return null;
}
